import {z} from 'zod';

const multiStringParam = z.union([z.string(), z.array(z.string())]).optional();

export const reportQuerySchema = z.object({
  state: z.string().optional(),
  orderType: multiStringParam,
  branch: multiStringParam,
  variant: multiStringParam,
  from: z.string().optional(),
  to: z.string().optional(),
});
